<template>
    <div style="height: 100%;">
        <div id="main" v-show="!rotaAninhada">
            <div class="page">
                <div class="tipos-servicos vertical-flow">
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">
                                {{ $t("configurar-recibos") }}
                            </h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{
                                            $t("despesas")
                                        }}</a>
                                    </li>
                                    <li>
                                        <a
                                            @click="
                                                $router.push({
                                                    name: 'des-configurar-recibos-list',
                                                })
                                            "
                                            aria-current="page"
                                            >{{ $t("configurar-recibos") }}</a
                                        >
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-buttons">
                            <button
                                v-if="permissao.create"
                                class="save-btn"
                                type="button"
                                tag="button"
                                @click="
                                    $router.push({
                                        name: 'des-configurar-recibos-new',
                                    })
                                "
                            >
                                {{ $t("adicionar") }}
                            </button>
                        </div>
                    </div>

                    <div class="search-and-filter">
                        <div class="search-bar">
                            <search-bar
                                :onSearch="debouncedOnSearch"
                            />
                        </div>
                        <div class="situacao-select">
                            <label v-text="$t('situacao')" />
                            <v-select
                                ref="situacaoInput"
                                class="is-100"
                                label="label"
                                :options="situacoes"
                                @input="onSituacaoChanged"
                                v-model="situacao"
                            >
                                <template slot="option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                                <template
                                    slot="selected-option"
                                    slot-scope="option"
                                >
                                    {{ $t(option.label) }}
                                </template>
                                <template slot="no-options">{{
                                    $t("sem-resultados")
                                }}</template>
                            </v-select>
                        </div>
                    </div>

                    <div class="registry-wrapper">
                        <container-loader
                            v-if="isLoading && !$store.getters.isLoading"
                        />
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            :data="configurarRecibos"
                            class="data-table"
                            @sort="sortTable"
                            backend-sorting
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :label="f.key != 'situacao' ? $t(f.key) : ''"
                                :width="f.width"
                                :class="{ 'excluir-field': f.key == 'situacao' }"
                                :sortable="f.sortable"
                                :custom-sort="f.sortFn"
                                v-slot="props"
                            >
                                <div v-if="f.key == 'titulo'">
                                    <router-link
                                        :to="{
                                            name: 'des-configurar-recibos-edit',
                                            params: { id: props.row.id },
                                        }"
                                    >
                                        <pre>{{ props.row[f.key] }}</pre>
                                    </router-link>
                                </div>
                                <div v-else-if="f.key == 'datahorainc'">
                                    {{ props.row['datahorainc'] | moment("L LT") }}
                                </div>

                                <div v-else-if="f.key == 'situacao'">
                                    <span v-if="props.row[f.key] == 1" >
                                        <b-button
                                            v-if="permissao.delete"
                                            type="is-danger"
                                            icon-right="delete"
                                            @click="promptForDesativar(props.row)"
                                            v-tippy 
                                            :title="$t('desativar')"
                                        />
                                    </span>
                                    <b-button
                                        v-else
                                        v-if="permissao.update"
                                        type="is-success"
                                        icon-right="check"
                                        @click="promptForReativar(props.row)"
                                        v-tippy 
                                        :title="$t('reativar')"
                                    />
                                </div>

                                <div v-else>
                                    {{ props.row[f.key] }}
                                </div>
                            </b-table-column>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import ConfigurarRecibosService from "@/services/despesas/ConfigurarRecibosService";
import ContainerLoader from "@/components/content/loader/ContainerLoader";

export default {
    beforeRouteUpdate(to, from, next) {
        if (
            to.name.includes("des-configurar-recibos") &&
            to.name != "des-configurar-recibos-list"
        ) {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            this.carregarDados(this.pagination.currentPage);
            next();
        }
    },
    components: {
        ContainerLoader,
    },
    data() {
        return {
            rotaAninhada: false,
            configurarRecibos: [],
            situacoes: [
                { id: 2, label: "todos" },
                { id: 1, label: "ativos" },
                { id: 0, label: "inativos" },
            ],
            situacao: { id: 2, label: "todos" },
            service: new ConfigurarRecibosService(this.$http, this.$router),
            fields: [
                { key: "codigo", width: 55, sortable: false },
                { key: "titulo", width: null, sortable: true, sortFn: null },
                { key: "datahorainc", width: 160, sortable: false, sortFn: null },
                { key: "situacao", width: 70, sortable: false, sortFn: null },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            delete: null,
            queryFilter: "",
            column: "datahorainc",
            order: "desc",
            permissao: {},
        };
    },
    created() {
        this.rotaAninhada = (
            this.$route.name.includes("des-configurar-recibos") &&
            this.$route.name != "des-configurar-recibos-list"
        );

        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];
        this.permissao = this.hasPermissionAccess(
            "despesas",
            "cadastros",
            "des-configurar-recibos"
        );
        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "configurar-recibos" },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },
    methods: {
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.carregarDados();
        },
        onSituacaoChanged(val) {
            let temp = null;
            if (val) {
                temp = this.situacoes.filter((v) => v.id == val.id);
                this.situacao = temp[0];
            } else {
                this.situacao = this.situacoes[0];
            }
            this.carregarDados();
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service
                .findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacao.id,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.configurarRecibos = value;
                    this.isEmpty = this.configurarRecibos.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage("error", "msg-erro-load");
                    console.error("Erro ao carregar.", e);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            let list = body.content.map((m) => {
                return {
                    id: m.idconfjasper,
                    codigo: m.idconfjasper,
                    titulo: m.titulo,
                    situacao: m.situacao,
                    datahorainc: m.datahorainc,
                    excluir: "excluir",
                };
            });
            return list;
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        promptForDesativar(row) {
            this.delete = row;
            this.$root.confirm({
                message: this.$t("msg-confirmacao-desativacao-n", { n: row.titulo }),
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        promptForReativar(row) {
            this.delete = row;
            this.$root.confirm({
                message: this.$t("msg-confirmacao-reativacao-n", { n: row.titulo }),
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.situacao == 1
                    ? "msg-erro-ao-desativar-config-recibo"
                    : "msg-erro-ao-reativar-config-recibo";
            let tempSituacao = this.delete.situacao == 1 ? 0 : 1;
            this.isLoading = true;
            let recibo = {
                idconfjasper: this.delete.id,
                situacao: tempSituacao,
            };
            this.service
                .updateSituacao(recibo)
                .then((r) => {
                    if (r.status == 200) {
                        if (r.content.situacao == 1) {
                            this.$root.showMessage(
                                "success",
                                "msg-sucesso-ao-reativar-config-recibo"
                            );
                            this.carregarDados(this.pagination.currentPage);
                        } else if (r.content.situacao == 0) {
                            this.$root.showMessage(
                                "success",
                                "msg-sucesso-ao-desativar-config-recibo"
                            );
                            this.carregarDados(this.pagination.currentPage);
                        }
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage(
                            "error",
                            "msg-problema-realizar-acao"
                        );
                    }
                })
                .catch((e) => {
                    console.error("Erro ao mudar propriedade.", e);
                    this.$root.showMessage("error", tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;
    }

    .tipos-servicos .search-and-filter {
        display: flex;
        justify-content: space-between;
        margin: 10px 0;
    }

    .tipos-servicos .search-and-filter {
        .search-bar {
            width: 80%;
            padding-right: 10px;
        }
        .situacao-select {
            width: 30%;
            div {
                height: 40px;
            }
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
            .situacao-select {
                width: 100%;
            }
        }
    }

    .tipos-servicos .search-and-filter .filter-bar {
        width: 31%;
    }
}
</style>
